import React from 'react';
import Grid from '@mui/material/Grid2'; // 👈 using Grid v2
import { Typography, Box } from '@mui/material';

const items = [
    'לוחות זמנים מעודכנים אחת לרבעון',
    'פירוט של כל שלבי המיזם – מתכנון ועד הפעלה',
    'חלוקה מפורטת לשלבים, מקטעים ולתתי-מקטעים',
    'תאריכי התחלה וסיום מתוכננים ועדכניים',
    'מעקב אחר עיכובים ביחס לתכנון המקורי',
    'דו"חות שינויים מפורטים בין דיווח לדיווח',
];

export default function NumberdItemComponent() {
    const mid = Math.ceil(items.length / 2);
    const leftColumn = items.slice(0, mid);
    const rightColumn = items.slice(mid);

    return (
        <Box sx={{ p: 2 }}>
            <Grid container spacing={2}>
                <Grid size={6}>
                    {leftColumn.map((item, index) => (
                        <Typography color="#0C3768" key={index}>{`${index + 1}. ${item}`}</Typography>
                    ))}
                </Grid>
                <Grid size={6}>
                    {rightColumn.map((item, index) => (
                        <Typography color="#0C3768" key={index}>{`${index + mid + 1}. ${item}`}</Typography>
                    ))}
                </Grid>
            </Grid>
        </Box>
    );
}
